export default __webpack_public_path__ + "static/12-100-8a857f331cb3845fc0b57ea68863360b.jpg";